module.exports = __webpack_public_path__ + "static/img/MA_1920_ru_awards3.bca9a62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MA_1920_ru_awards3.jpg
// module id = tuyI
// module chunks = 1